import { get } from 'lodash/fp';
import { flow } from 'fp-ts/function';
import { combineReducers } from 'redux';
import { createReducer, createAsyncActionTypes } from '@mews/framework';
import { PlatformDocumentExtent } from '@mews-commander/enums';
import { ApplicationState, PlatformDocuments, CommanderThunkAction, AsyncAction } from '@mews-commander/types';
import { createFetchAction } from '@mews-commander/utils';
import moduleSelector from '../selector';
import prefix from '../prefix';
import { createEntityMetaReducer, MetaState } from './utils';

interface PlatformDocumentsModuleState extends MetaState {
    data: Partial<PlatformDocuments>;
}

const PLATFORM_DOCUMENTS_FETCH = prefix('PLATFORM_DOCUMENTS_FETCH');
const [PLATFORM_DOCUMENTS_FETCH_STARTED, PLATFORM_DOCUMENTS_FETCH_SUCCEEDED, PLATFORM_DOCUMENTS_FETCH_FAILED] =
    createAsyncActionTypes(PLATFORM_DOCUMENTS_FETCH);

export const NAME = 'platformDocuments';

const dataReducer = createReducer(
    {},
    {
        [PLATFORM_DOCUMENTS_FETCH_SUCCEEDED]: (state: PlatformDocuments, payload: PlatformDocuments) => ({
            ...state,
            ...payload,
        }),
    }
);
const metaReducer = createEntityMetaReducer({
    STARTED: PLATFORM_DOCUMENTS_FETCH_STARTED,
    SUCCEEDED: PLATFORM_DOCUMENTS_FETCH_SUCCEEDED,
    FAILED: PLATFORM_DOCUMENTS_FETCH_FAILED,
});

export const platformDocumentsReducer = combineReducers({
    data: dataReducer,
    meta: metaReducer,
});

interface FetchPlatformDocumentsParameters {
    extent: Partial<Record<PlatformDocumentExtent, boolean>>;
}

export const fetchPlatformDocuments =
    ({ extent }: FetchPlatformDocumentsParameters): CommanderThunkAction<AsyncAction<PlatformDocuments>> =>
    async (dispatch, _getState, { container }) => {
        const promise = container().platformComponent.getDocuments({ extent }) as Promise<PlatformDocuments>;

        return dispatch(createFetchAction(PLATFORM_DOCUMENTS_FETCH, promise));
    };

const getPlatformDocumentsState = flow<[ApplicationState], unknown, PlatformDocumentsModuleState>(
    moduleSelector,
    get(NAME)
);

const getPlatformDocuments = flow(getPlatformDocumentsState, get('data'));

export const getAddOnsTCsHtml = flow(getPlatformDocuments, get('addOnsTermsAndConditionsHtml'));
export const getMarketplaceTCsHtml = flow(getPlatformDocuments, get('marketplaceTermsAndConditionsHtml'));
